export default __webpack_public_path__ + "static/media/image-sapin.ac0e9368.png";